<main id="onsip-instacall" class="instacall">
  <div class="lost-local-media" data-*ngIf="lostLocalMedia">
    <div class="help-content">
      <p>
        Oops! We can't <span class="lost-local-video">see</span> <span class="lost-both">or</span>
        <span class="lost-local-audio">hear</span> you! Please ensure your
        <span class="lost-local-video">camera</span> <span class="lost-both">and</span>
        <span class="lost-local-audio">microphone</span> <span class="lost-both">are</span>
        <span class="not-lost-both">is</span> still plugged in and turned on, then reload this page.
      </p>
    </div>

    <button class="help-done" (click)="showHelp = ''">Okay, I got it</button>
  </div>
  <div id="overlay" data-*ngIf="showOverlay"></div>

  <div
    id="popup"
    [ngClass]="{
      'theme-flat': isFlat,
      'theme-skeu': !isFlat,
      'theme-light': isLight,
      'theme-dark': !isLight
    }"
  >
    <onsip-call-video-container
      data-*ngIf="call &amp;&amp; call.videoAvailable"
      [callUuid]="call.uuid"
    >
    </onsip-call-video-container>

    <div id="multi-box">
      <div id="help-overlay" data-*ngIf="showHelp.length > 0">
        <div class="help-content" [ngClass]="{ 'help-small-font': !useName }">
          <!-- first help screen -->
          <div class="help-paragraph" data-*ngIf="showHelp === 'helpFirst'">
            <span class="help-line" data-*ngIf="browser.name === 'chrome'"
              >Please hit the 'Allow' button above to share your<span data-*ngIf="hasVideo">
                camera and</span
              >
              microphone.</span
            >
            <span class="help-line" data-*ngIf="browser.name === 'firefox'"
              >Please share your microphone <span data-*ngIf="hasVideo"> and camera</span> by
              clicking on the icon shown below in the top left hand corner of your browser.</span
            >
          </div>
          <button
            data-*ngIf="showHelp === 'helpFirst'"
            (click)="showHelp = 'helpSecond'"
            class="help-next"
          >
            Help! I don&apos;t see an 'Allow' button.
          </button>
          <!-- end first help screen -->

          <!-- second help screen -->
          <div
            class="help-paragraph"
            data-*ngIf="browser.name === 'chrome' &amp;&amp; showHelp === 'helpSecond'"
          >
            <span class="help-line"
              >You should see the icon below in the top right hand corner of your browser.</span
            >
            <span class="help-line help-img">
              <img [src]="'resources/img/icons/chrome_camera_icon.png'" alt="Chrome Help Image" />
            </span>
            <span class="help-line"
              >Click on it. Select the option that starts &quot;Always Allow...&quot; and hit
              done.</span
            >
            <span class="help-line">This phone should then be reloaded.</span>
          </div>
          <div
            class="help-paragraph"
            data-*ngIf="browser.name === 'firefox' &amp;&amp; showHelp === 'helpSecond'"
          >
            <span class="help-line"
              >Choose your devices to share, and click the &quot;Share selected devices&quot;
              button.</span
            >
            <span class="help-line help-img">
              <img [src]="'resources/img/icons/ff_camera_icon.png'" alt="Firefox Help Image" />
            </span>
          </div>
          <!-- end second help screen -->

          <div
            class="help-paragraph"
            data-*ngIf="showHelp !== 'helpFirst' &amp;&amp; showHelp !== 'helpSecond'"
          >
            <span class="help-line" data-*ngIf="showHelp === 'noJs'"
              >We've detected that you have Javascript disabled. Please enable Javascript and try
              again.</span
            >
            <span class="help-line" data-*ngIf="showHelp === 'noBrowser'"
              >Your current browser does not support web calls. Please try with the latest version
              of <a href="http://www.google.com/chrome" target="_blank">Chrome</a> or
              <a href="http://www.mozilla.org/en-US/" target="_blank">Firefox</a>.</span
            >
            <span class="help-line" data-*ngIf="showHelp === 'missingParams'"
              >Oops! an error has occurred.</span
            >
            <span class="help-line" data-*ngIf="showHelp === 'callError'"
              >Oops! This call could not be completed. We apologize for the inconvenience.</span
            >
            <span
              class="help-line"
              data-*ngIf="showHelp === 'callComplete'"
              [innerHtml]="postMessage"
            >
            </span>
            <span class="help-line alternate-info" data-*ngIf="altPhone || altEmail || altWebsite">
              You can also always contact us via:
              <ul class="param-alts">
                <li data-*ngIf="altPhone">
                  <span>Phone</span><span [innerHtml]="altPhone"></span>
                </li>
                <li data-*ngIf="altEmail">
                  <span>Email</span><a href="mailto:{{ altEmail }}" [innerHtml]="altEmail"></a>
                </li>
                <li data-*ngIf="altWebsite">
                  <span>Website</span
                  ><a href="http://{{ altWebsite }}" target="_blank" [innerHtml]="altWebsite"></a>
                </li>
              </ul>
            </span>
          </div>
          <button
            data-*ngIf="showHelp === 'callComplete'"
            class="help-done call-complete"
            (click)="showHelp = ''"
          >
            Let me make another call.
          </button>
        </div>
      </div>

      <div
        id="status"
        [ngClass]="{
          foreground: showOverlay,
          'is-welcome': multiBox === 'welcome' || multiBox === 'connecting'
        }"
      >
        <div id="welcome" data-*ngIf="multiBox === 'welcome'">
          <p [innerHtml]="instructions"></p>
        </div>
        <div id="connecting-wrap" data-*ngIf="multiBox === 'connecting'">
          <span id="connecting"
            >Connecting
            <div></div>
            <div></div>
            <div></div
          ></span>
        </div>
        <div id="call-status" data-*ngIf="multiBox === 'status'">
          <div [innerHtml]="callDuration | duration"></div>
        </div>
      </div>

      <div id="intro" data-*ngIf="multiBox === 'welcome' || multiBox === 'connecting'">
        <input
          id="name"
          type="text"
          name="name"
          placeholder="Enter your full name"
          [ngClass]="{ error: callerNameEmpty }"
          [(ngModel)]="callerName"
          data-*ngIf="useName"
          (keydown.Enter)="dial()"
          (focus)="clearNameError()"
        />
      </div>

      <div data-*ngIf="multiBox === 'status' &amp;&amp; call">
        <div class="call-controls-row">
          <button
            title="{{ !call.audio ? 'Unm' : 'M' }}ute Microphone"
            class="call-controls-item"
            data-*ngIf="call.connected"
            (click)="muteAudio()"
          >
            <img
              class="call-controls-img call-controls__audio-mute"
              alt="!call.audio ? 'Unmute' : 'Mute'"
              [src]="
                !call.audio
                  ? 'resources/img/instacall/microphone_mute.png'
                  : 'resources/img/instacall/microphone_unmute.png'
              "
            />
          </button>

          <button
            title="{{ !call.video ? 'Unm' : 'M' }}ute Video"
            class="call-controls-item"
            data-*ngIf="call.connected &amp;&amp; call.videoAvailable"
            (click)="muteVideo(!!call.video)"
          >
            <img
              class="call-controls-img call-controls__video-mute"
              alt="!call.video ? 'Unmute Video' : 'Mute Video' "
              [src]="
                !call.video
                  ? 'resources/img/instacall/video_no.png'
                  : 'resources/img/instacall/video_yes.png'
              "
            />
          </button>

          <onsip-instacall-volume [call]="call.uuid"> </onsip-instacall-volume>
        </div>

        <onsip-instacall-dialpad data-*ngIf="hasDtmf"> </onsip-instacall-dialpad>
      </div>

      <div class="call-control-buttons" data-*ngIf="hasVideo &amp;&amp; multiBox === 'welcome'">
        <button
          [disabled]="multiBox !== 'welcome'"
          (click)="dial()"
          title="Connect With Audio"
          class="call-controls-button half-button dial-audio green"
        >
          <img [src]="'resources/img/phone.png'" alt="Connect with Audio" />
        </button>
        <button
          [disabled]="multiBox !== 'welcome'"
          (click)="dial(true)"
          title="Connect With Video"
          class="call-controls-button half-button dial-video green"
        >
          <img [src]="'resources/img/video/enabled.png'" alt="Connect With Video" />
        </button>
      </div>
      <button
        id="multi-button"
        class="call-controls-button"
        data-*ngIf="!hasVideo || multiBox !== 'welcome'"
        (click)="multiBox === 'welcome' ? dial() : endCall()"
        [ngClass]="{'orange': multiBox !== 'welcome',
                    'green': multiBox === 'welcome',
                    'foreground': showOverlay,
                    'multi-has-dtmf': multiBox === 'status' &amp;&amp; hasDtmf}"
        [innerHtml]="
          multiBox === 'welcome'
            ? 'Connect Now'
            : multiBox === 'connecting'
            ? 'Cancel Call'
            : 'End Call'
        "
      ></button>
    </div>
    <div id="bottom" [ngClass]="{ skinny: smallView }">
      <p id="help">
        <a href="https://support.onsip.com/hc/en-us/sections/200782090-InstaCall" target="_blank"
          >Help</a
        >
      </p>
      <a id="onsip" href="https://www.onsip.com" target="_blank"
        ><span>Powered by</span
        ><img id="onsip-pic" alt="OnSIP" [src]="'resources/img/onsip-white.svg'"
      /></a>
    </div>
  </div>
</main>
<footer></footer>
